export const TABLE_CONSTANTS = {
  DEFAULT_PAGE_SIZE: 10,
  STYLING: {
    CELL_PADDING: {
      LEFT: 'pl-5',
      RIGHT: 'pr-4',
      TOP: 'pt-5',
      BOTTOM: 'pb-5',
    },
    COLORS: {
      HEADER_BG: 'bg-neutral-200',
      TABLE_BG: 'bg-neutral-0',
      TEXT: 'text-typography',
      TEXT_LIGHT: 'text-typography-light',
    },
    BORDERS: {
      TABLE: 'border border-neutral-400 rounded-md shadow-md',
      CELL: 'border-b',
    },
  },
};
